import React from "react";
import Outlets from "../../components/trisara/outlets";
import { useParams } from "react-router-dom";
import useFetch from "../../utils/useFetch";
import { API_URL } from "../../constants";
import NotFound from "../general/notFound";
import Loader from "../../components/general/loader";

const Trisara = () => {
  const { id } = useParams();
  const { data: franchise, error } = useFetch(`${API_URL}franchises/${id}`);

  return (
    <>
      {franchise ? (
        <>
          <div className="px-2 lg:grid lg:grid-cols-3 lg:gap-4 lg:px-20">
            <div className="franchise-text">
              <div className="wrapper">
                <img
                  className="pb-5 lg:w-[30vw]"
                  src={franchise.logo}
                  alt="logo"
                />
                <p className="mx-2 whitespace-pre-wrap text-justify">
                  {franchise.description}
                </p>
              </div>
            </div>
            <div className="relative top-[-100px] mx-auto block w-fit lg:hidden">
              <div className="scroll mx-auto block"></div>
              <p className="pt-5 text-xs font-semibold uppercase">
                Scroll Down
              </p>
            </div>
            <Outlets franchise={franchise} error={error} id={id} />
          </div>
        </>
      ) : error ? (
        <NotFound />
      ) : (
        <p className="pt-32 text-center">
          <Loader />
        </p>
      )}
    </>
  );
};

export default Trisara;
